<script setup lang="ts">
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  data: Populated<AboutUs>['ourTeam']
}>()
const lp = useLocalePath()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 px-2 pt-16">
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <Heading as="h2" size="caption" class="mb-2">{{ data.title }}</Heading>
      <Heading as="h3" size="medium" class="mb-10 flex flex-col px-10 lg:px-0">
        {{ data.headline }}
      </Heading>

      <AboutUsTeamCards v-if="data.people" :data="data.people" />

      <Cta :href="lp('/careers')" :label="$t('company.ctaLabel')" />
    </div>
  </Container>
</template>
